export default {
    lang: {
        name: 'Community Rating'
    }
}